import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputSelect from '../../../FormFields/Select';
import withFieldActions from '../withFieldActions';
import Checkbox from '../../../FormFields/Checkbox';
import ConfigService from "../../../../Services/api/Config";
import Utils from "../../../../Services/Utils";


export class PropertyInfoWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      group: null,
      subgroup: null,
      groups: [],
      subgroups: [],
      fields: [],
    };
  }

  componentDidMount() {
    const { propertyFields, internalField } = this.props;
    let groups = [];
    let subgroups = [];
    let fields = [];
    let group = null;
    let subgroup = null;
    if (propertyFields) {
      if (!internalField.group && (internalField.field || internalField.subgroup)) {
        group = { id: 0, name: 'Other'};
        internalField.group = 0;
      }
      propertyFields.map((item) => {
        groups[item.group ? item.group.id : 0] = item.group ? item.group : {id: 0, name: 'Other'};
        if (!Utils.isNull(internalField.group)) {
          if (item.group && (internalField.group === item.group.id)) {
            group = item.group;
            if (item.fields.length > 0) {
              subgroups.push(item);
            }
          }
          else if (!item.group) {
            subgroups.push(item);
          }
          if (internalField.subgroup === item.id) {
            subgroup = item;
            fields = item.fields;
          }
        }
      });
      this.setState({
        group: group,
        groups: groups,
        subgroup: subgroup,
        subgroups: subgroups,
        fields: fields
      });
    }
  }

  generateOptions = () => {
    const { propertyFields, internalField } = this.props;
    let subgroups = [];
    let fields = [];
    if (propertyFields) {
      if (!internalField.group && (internalField.field || internalField.subgroup)) {
        internalField.group = 0;
      }
      propertyFields.map((item) => {
        if (!Utils.isNull(internalField.group)) {
          if ((!item.group) || (item.group && (item.group.id === internalField.group) && (item.fields.length > 0))) {
            subgroups.push(item);
          }
          if (!Utils.isNull(internalField.subgroup) && (internalField.subgroup === item.id)) {
            fields = item.fields;
          }
        }
      });
    }
    return { subgroups: subgroups, fields: fields };
  };

  getLabel = (field) => {
    let label = 'Property Field:';
    if (field) {
      label = this.state.group.label + ' > ' + this.state.subgroup.label + ' > ' + field.label + ':';
    }
    return label;
  };

  handleChangeGroup = (group, changeFieldValue) => {
    changeFieldValue('group', group.value);
    changeFieldValue('subgroup', null);
    changeFieldValue('field', null);
    const { propertyFields } = this.props;
    let subgroups = [];
    let fields = [];
    if (propertyFields) {
      propertyFields.map((item) => {
        if ((!item.group && !group.value)  || (item.group && (item.group.id === group.value) && (item.fields.length > 0))) {
          subgroups.push(item);
        }
      });
      this.setState({
        group: group,
        subgroup: null,
        subgroups: subgroups,
        fields: fields
      });
    }
  };

  handleChangeSubGroup = (subgroup, changeFieldValue) => {
    changeFieldValue('subgroup', subgroup.value);
    changeFieldValue('field', null);
    const { propertyFields } = this.props;
    let fields = [];
    if (propertyFields) {
      propertyFields.map((item) => {
        if (item.id === subgroup.value) {
          fields = item.fields;
        }
      });
      this.setState({
        subgroup: subgroup,
        fields: fields
      });
    }
  };

  handleChangeField = (field, changeFieldValue) => {
    changeFieldValue('field', field.value);
    changeFieldValue('label', this.getLabel(field));
  };

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const { groups } = this.state;
    const { subgroups, fields } = this.generateOptions();
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputSelect label='Select a group' value={ internalField.group }
                     onChange={ (v) => { this.handleChangeGroup(v, changeFieldValue); } }
                     options={ groups.map(item => {return { value: item.id, label: item.name };}) }/>
        <InputSelect label='Select a subgroup' value={ internalField.subgroup }
                     onChange={ (v) => { this.handleChangeSubGroup(v, changeFieldValue); } }
                     options={ subgroups.map(item => {return { value: item.id, label: item.name };}) }/>
        <InputSelect label='Select a field' required value={ internalField.field }
                     onChange={ (v) => { this.handleChangeField(v, changeFieldValue); } }
                     options={ fields.map(item => {return { value: item.key, label: item.name };}) }
                     error={ internalField.errors['field'] }
                     onError={ (error) => changeFieldError('field', error) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, api } = this.props;
    const styleDescription = {
      color: ConfigService.getColor('secondaryColor'),
    };
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Property Field',
      className: 'WrapperWidget_Inline'
    };
    return (
      <WrapperWidget {...props}>
        <div className='PropertyInfoWidget'>
          <div  className='Widget_Label'>
            <span className='Widget_Label_Description' style={ styleDescription }>{ value || (api ? api.getFieldsVerbiage(field, 'description') : field.description)}</span>
          </div>
        </div>
      </WrapperWidget>
    );
  }
}

export const PropertyInfoWidgetEditable = withFieldActions(PropertyInfoWidget);